import React, { useEffect } from 'react';
import { generateQRCode } from 'apis/qrCodeApi'; // Import your frontend wrapper

const QRCodeGenerator = ({ url, options, onQRCodeGenerated, setLoading, setError }) => {
  useEffect(() => {
    const fetchQRCode = async () => {
      setError(''); // Reset error state
      setLoading(true); // Start loading

      try {
        const qrCodeUrl = await generateQRCode(url, options);
        onQRCodeGenerated(qrCodeUrl); // Call the callback with the generated QR code URL
      } catch (err) {
        setError('Failed to generate QR Code');
        console.error('Error generating QR Code:', err);
      } finally {
        setLoading(false); // Stop loading after the request completes
      }
    };

    fetchQRCode(); // Call the function to fetch the QR code
  }, [url, options]); // Include options in the dependency array

  return null; // This component doesn't render anything
};

export default QRCodeGenerator;

